import React from "react";
import { Container } from "./style";

export const PageTitle = ({ children, ...props }) => {
    return <Container {...props}>{children}</Container>;
};
